"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const __1 = require("../../..");
function FooterSocialLinks({ children }) {
    return ((0, jsx_runtime_1.jsx)(__1.Grid.Row, { className: "usa-footer__social-links", gaps: true, gapSize: 1, children: children }));
}
exports.default = FooterSocialLinks;
